// Mirror of backend UnitConversion: only mass (g/kg) and volume (ml/L)
// interconvert; any other unit is compatible only with itself. Recipe
// quantities must be saved in a unit compatible with the inventory item's
// stock unit or the backend rejects the save.

const FAMILY: Record<string, string[]> = {
  g: ['g', 'kg'],
  kg: ['g', 'kg'],
  ml: ['ml', 'L'],
  l: ['ml', 'L'],
};

/** Units a recipe line may use for an inventory item stocked in `stockUnit`. */
export const compatibleUnits = (stockUnit: string): string[] => {
  const trimmed = stockUnit.trim();
  return FAMILY[trimmed.toLowerCase()] ?? [trimmed];
};

export const areUnitsCompatible = (unit: string, stockUnit: string): boolean =>
  compatibleUnits(stockUnit).some((u) => u.toLowerCase() === unit.trim().toLowerCase());

/** Cantidad de stock sin ruido: el backend guarda 6 decimales, y 99.878412 kg no se lee en una tabla. */
export const formatStock = (value: number, decimals: number = 3): string =>
  String(Number(value.toFixed(decimals)));

const TO_BASE_UNIT: Record<string, number> = { g: 1, kg: 1000, ml: 1, l: 1000 };

/** Convierte a la unidad de stock. Lo incompatible pasa sin convertir, igual que en el backend. */
export const convertToStockUnit = (quantity: number, unit: string, stockUnit: string): number => {
  if (!areUnitsCompatible(unit, stockUnit)) return quantity;
  const from = TO_BASE_UNIT[unit.trim().toLowerCase()];
  const to = TO_BASE_UNIT[stockUnit.trim().toLowerCase()];
  return from && to ? (quantity * from) / to : quantity;
};
